const ContactUsForm = {
  title: 'Contact Us',
  subtitle: 'Let us know how we can help you get started.',
  fields: {
    email: {
      label: 'Email',
      placeholder: 'Email',
      dataTestId: 'contact-us-email',
    },
    first_name: {
      label: 'First Name',
      placeholder: 'First Name',
      dataTestId: 'contact-us-first-name',
    },
    last_name: {
      label: 'Last Name',
      placeholder: 'Last Name',
      dataTestId: 'contact-us-last-name',
    },
    company_name: {
      label: 'Company Name (Optional)',
      placeholder: 'Company Name (Optional)',
      dataTestId: 'contact-us-company-name',
    },
    template_experience: {
      label:
        'Have you worked with a Word Template (.dot, .dotx) or Excel Sheet Template (.xlt, .xltx, .xltm) before?',
      dataTestId: 'contact-us-template-experience',
      options: [
        {
          label: 'Word Template (.dot, .dotx)',
          value: 'word',
          dataTestId: 'contact-us-template-word',
        },
        {
          label: 'Excel Sheet Template (.xlt, .xltx, .xltm)',
          value: 'excel',
          dataTestId: 'contact-us-template-excel',
        },
      ],
    },
    monthly_doc_volume: {
      label:
        'On average, around how many docs do you usually edit or update on a single month?',
      placeholder: 'Number of documents',
      dataTestId: 'contact-us-monthly-volume',
      max: 1_000_000,
    },
    message: {
      label: 'Your Message',
      placeholder: 'Your Message',
      dataTestId: 'contact-us-message',
    },
  },
  actions: {
    submitButton: {
      label: 'Submit',
      dataTestId: 'contact-us-submit-button',
    },
  },
};

export default ContactUsForm;
